module.exports = __webpack_public_path__ + "static/setFilter-ad571fc2a8f53d09b29cb9a27c53054b.gif";